import styled from "styled-components";
import { Flex } from "antd";

// ─── Page Shell ───────────────────────────────────────────────────────────────
// Extends AntD Flex; direction (vertical) is set via prop in JSX.
// Visual-only: height, overflow, background, border-radius, border, box-shadow.

export const SkillsMapContainerStyled = styled(Flex)`
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
`;

// ─── Content Area ─────────────────────────────────────────────────────────────
// Extends AntD Flex; flex growth (flex="1") is set via prop in JSX.
// Visual-only: overflow-y, padding.

export const ContentAreaStyled = styled(Flex)`
  flex-direction: column;
  overflow-y: auto;
  padding: 20px clamp(12px, 3vw, 24px) 24px;
`;

// ─── Coming Soon Placeholder ──────────────────────────────────────────────────
// Extends AntD Flex; align + justify are set via props in JSX.
// Visual-only: padding, font-size.

export const ComingSoonStyled = styled(Flex)`
  width: 100%;
  padding: 64px 0;
  font-size: 16px;
`;
